var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIphoneWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-18049 -3829 18.545 18.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18049 -3829)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H18.545V18.545H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.8,9.02a11.706,11.706,0,0,0,5.092,5.092l1.7-1.7a.768.768,0,0,1,.788-.185,8.815,8.815,0,0,0,2.759.44.775.775,0,0,1,.773.773v2.7a.775.775,0,0,1-.773.773A13.135,13.135,0,0,1,3,3.773.775.775,0,0,1,3.773,3h2.7a.775.775,0,0,1,.773.773,8.778,8.778,0,0,0,.44,2.759A.775.775,0,0,1,7.5,7.32Z",
    transform: "translate(-0.682 -0.682)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneWhite);
export default __webpack_public_path__ + "static/media/iphone-white.8a03e9167d37a574e3619d71812c70b6.svg";
export { ForwardRef as ReactComponent };